<!-- FILTER BAR -->
<section class="filtering">
  <div class="left">
    <h2>All {{ canvasType }}s</h2>
  </div>
  <div class="center" *ngIf="showData">
    <span class="error" *ngIf="error">{{ error }}</span>
    <span class="error" *ngIf="!error">&nbsp;</span>
    <div class="searchBox">
      <form [formGroup]="canvasForm">
        <mat-form-field style="width: 80%">
          <input
            matInput
            placeholder="filter {{ canvasType }}s"
            formControlName="searchTerm"
            name="Search"
            (keyup)="applyFilter($event)"
            aria-label="Search"
          />
        </mat-form-field>

        <fa-icon
          [icon]="faSearch"
          matSuffix
          mat-button
          class="searchIcon"
        ></fa-icon>
      </form>
    </div>
  </div>
</section>

<ng-container *ngIf="!showData">
  <div class="loading-spinner">
    <mat-spinner strokeWidth="3" diameter="50"></mat-spinner>
    Loading {{ canvasType }}s
  </div>
</ng-container>

<div [hidden]="!showData">
  <div [hidden]="dataSource && dataSource.length <= 0">
    <table mat-table [dataSource]="dataSource" matSort id="dataTable">
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell noItems" colspan="4">
          No {{ canvasType }}s available to be shown
        </td>
      </tr>
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>
        <th mat-header-cell *matHeaderCellDef style="font-size: 10px">
          Select Fields
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Category Column -->
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="module">
          Category
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.category_id | categoryName : categories }}
        </td>
      </ng-container>
      <!-- access Column -->
      <ng-container matColumnDef="access">
        <th mat-header-cell *matHeaderCellDef>SG Access</th>
        <td mat-cell *matCellDef="let element" class="sgIcon">
          <fa-icon
            [icon]="faShieldKeyhole"
            mat-button
            [matTooltip]="getSecurityGroups(element.canvasGroups)"
            matTooltipPosition="right"
            matTooltipClass="report-home-tooltip"
          ></fa-icon>
        </td>
      </ng-container>
      <!-- published Column -->
      <ng-container matColumnDef="published">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at">
          Last Published
        </th>
        <td mat-cell *matCellDef="let element">
          {{ formatDate(element.published_at) }}
        </td>
      </ng-container>
      <!-- modified Column -->
      <ng-container matColumnDef="modified">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="updated_at">
          Last Modified
        </th>
        <td mat-cell *matCellDef="let element">
          {{ formatModified(element.updated_at) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="selection.toggle(row)"
      ></tr>
    </table>

    <span class="selectedItems" *ngIf="selection.selected.length > 0"
      >Currently {{ selection.selected.length }} {{ canvasType }}(s)
      selected</span
    >
    <mat-paginator
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 20, 50, 100, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
